import DashboardIcon from "@mui/icons-material/Dashboard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PeopleIcon from "@mui/icons-material/People";
import EngineeringIcon from "@mui/icons-material/Engineering";
import BadgeIcon from "@mui/icons-material/Badge";
import InventoryIcon from "@mui/icons-material/Inventory2";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import WebIcon from "@mui/icons-material/Web";
import MathIcon from "@mui/icons-material/Functions";
import RateReviewIcon from "@mui/icons-material/RateReview";
import VerifiedIcon from "@mui/icons-material/Verified";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import { ACCESS } from "../utils/rolePermissions";

export const NAV_SECTIONS = [
  {
    id: "inicio",
    label: null,
    items: [
      {
        text: "Resumen",
        icon: DashboardIcon,
        path: "/",
        roles: ACCESS.DASHBOARD,
        pin: true,
      },
      {
        text: "Mi agenda",
        icon: CalendarMonthIcon,
        path: "/agenda",
        roles: ACCESS.AGENDA,
        pin: true,
      },
    ],
  },
  {
    id: "administracion",
    label: "Administración",
    icon: WorkspacesOutlinedIcon,
    items: [
      {
        text: "Calendario",
        icon: CalendarMonthIcon,
        path: "/calendario",
        roles: ACCESS.OPERATIONS,
        pin: true,
      },
      {
        text: "Servicios",
        icon: BuildCircleIcon,
        path: "/servicios",
        roles: ACCESS.OPERATIONS,
        pin: true,
      },
      // {
      //   text: "Rutas",
      //   hint: "En mantenimiento",
      //   icon: AltRouteIcon,
      //   path: "/rutas",
      //   roles: ACCESS.ADMIN_ONLY,
      //   pin: true,
      // },
      {
        text: "Certificados",
        hint: "Folios y documentos",
        icon: VerifiedIcon,
        path: "/certificados",
        roles: ACCESS.ADMIN_ONLY,
      },
      {
        text: "Clientes",
        icon: PeopleIcon,
        path: "/clientes",
        roles: ACCESS.OPERATIONS,
        pin: true,
      },
      {
        text: "Distribución",
        hint: "Reporte público",
        icon: WebIcon,
        path: "/distribucion",
        roles: ACCESS.OPERATIONS,
      },
    ],
  },
  {
    id: "supervision",
    label: "Supervisión",
    icon: VerifiedUserOutlinedIcon,
    items: [
      {
        text: "Inventario",
        hint: "Materiales y stock",
        icon: InventoryIcon,
        path: "/inventario",
        roles: ACCESS.INVENTARIO,
      },
      {
        text: "Recursos Humanos",
        hint: "Técnicos y expedientes",
        icon: BadgeIcon,
        path: "/tecnicos",
        roles: ACCESS.RH_MODULE,
      },
      {
        text: "Evaluación",
        hint: "Desempeño mensual",
        icon: RateReviewIcon,
        path: "/evaluacion",
        roles: ACCESS.EVALUACION,
      },
    ],
  },
  {
    id: "sistema",
    label: "Sistema",
    icon: TuneOutlinedIcon,
    items: [
      {
        text: "Centro de datos",
        hint: "Indicadores directivos",
        icon: MathIcon,
        path: "/analisis",
        roles: ACCESS.ADMIN_ONLY,
      },
      {
        text: "Rendimiento",
        hint: "Carga operativa",
        icon: AssessmentIcon,
        path: "/rendimiento",
        roles: ACCESS.ADMIN_ONLY,
      },
      {
        text: "Programación",
        hint: "Recurrencia mensual",
        icon: CalendarMonthIcon,
        path: "/programacion",
        roles: ACCESS.ADMIN_ONLY,
      },
      {
        text: "Seguridad",
        hint: "Accesos, tokens y sesiones",
        icon: ShieldOutlinedIcon,
        path: "/seguridad",
        roles: ACCESS.ADMIN_ONLY,
      },
      {
        text: "Dev",
        hint: "Herramientas internas",
        icon: EngineeringIcon,
        path: "/dev",
        roles: ACCESS.ADMIN_ONLY,
      },
    ],
  },
];

export const ROLE_LABELS = {
  admin: "Administrador",
  rh: "Recursos humanos",
  scheduler: "Programación",
  supervisor: "Supervisor",
  calidad: "Calidad",
  technician: "Técnico",
  costumer: "Cliente",
};

export const isNavPathActive = (pathname, path) => {
  if (path === "/") return pathname === "/";
  return pathname === path || pathname.startsWith(`${path}/`);
};

const withSection = (item, section) => ({ ...item, section: section.label });

/** Atajos diarios + menús del resto. Un ítem suelto no se esconde en un menú. */
export const buildDesktopEntries = (sections) => {
  const links = [];
  const rest = [];

  for (const section of sections) {
    for (const item of section.items) {
      if (item.pin) {
        links.push({
          type: "link",
          key: item.path,
          item: withSection(item, section),
        });
      }
    }
  }

  for (const section of sections) {
    if (!section.label) continue;
    const leftover = section.items.filter((item) => !item.pin);
    if (leftover.length === 1) {
      rest.push({
        type: "link",
        key: leftover[0].path,
        item: withSection(leftover[0], section),
      });
    } else if (leftover.length > 1) {
      rest.push({
        type: "group",
        key: section.id || section.label,
        label: section.label,
        icon: section.icon,
        items: leftover.map((item) => withSection(item, section)),
      });
    }
  }

  if (!links.length || !rest.length) return [...links, ...rest];
  return [...links, { type: "divider", key: "nav-divider" }, ...rest];
};

export const flattenDesktopEntries = (entries) =>
  entries.flatMap((entry) => {
    if (entry.type === "link") return [entry.item];
    if (entry.type === "group") return entry.items;
    return [];
  });
